// extracted by mini-css-extract-plugin
export default {"Badge":"styles_Badge__zvbed","active":"styles_active__asKro"};